const LoadingSpinner = ({ size = "medium", message = "Loading..." }) => {
  const sizeClass = {
    small: "h-6 w-6 border-4",
    medium: "h-8 w-8 border-4",
    large: "h-12 w-12 border-8",
  }[size] || "h-8 w-8 border-4";

  return (
    <div className="flex flex-col items-center justify-center space-y-4 p-4">
      <div
        className={`animate-spin rounded-full border-t-4 border-primary ${sizeClass} border-gray-300`}
      ></div>
      {message && (
        <p className="text-lg text-primary font-semibold">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;
